<script lang="ts">
  // One video tile. Plays the given camera slug via the MSE proxy; restarts
  // cleanly whenever the slug changes and tears down on destroy.
  import { onDestroy } from "svelte";
  import { MsePlayer } from "./mse";
  import { streamWsUrl } from "./api";

  export let slug: string | null = null;
  export let name = "";

  let video: HTMLVideoElement;
  let player: MsePlayer | null = null;
  let status: "idle" | "connecting" | "live" | "error" = "idle";
  let detail = "";

  function restart(currentSlug: string | null): void {
    player?.stop();
    player = null;
    status = "idle";
    detail = "";
    if (!currentSlug || !video) return;
    status = "connecting";
    player = new MsePlayer(video, streamWsUrl(currentSlug), (s, d) => {
      status = s;
      detail = d ?? "";
    });
    player.start();
  }

  // Re-run whenever slug changes (and once `video` is bound).
  $: if (video) restart(slug);

  onDestroy(() => player?.stop());
</script>

<div class="cell-video">
  <!-- muted + playsinline so autoplay works without a user gesture -->
  <video bind:this={video} muted playsinline autoplay></video>

  {#if status !== "live"}
    <div class="cell-overlay">
      {#if status === "idle"}
        <span class="cell-empty">No camera selected</span>
      {:else if status === "connecting"}
        <span class="cell-spinner">Connecting{detail ? ` — ${detail}` : "…"}</span>
      {:else if status === "error"}
        <span class="cell-error">⚠ {detail || "stream error"}</span>
      {/if}
    </div>
  {/if}

  {#if slug && status === "live"}
    <div class="cell-label">{name}</div>
  {/if}
</div>
